export const incident = {
  table: {
    id: 'ID',
    message: 'Message',
    path: 'Path',
    detail: 'Incident details',
  },
  pageHeader: {
    title: 'Incident',
  },
}
